export const LIVE_TYPES = {
    ASSERTIVE: 'assertive',
    POLITE: 'polite',
};
